import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";

import LoaderPopUp from "../../../../../../../components/loader/loader";
import {
  setOrderId,
  setPaytmDataInStore,
} from "../../../../../../../redux/payment_gateway/action";
import { url_301 } from "../../../../../../../custom_utilities/api_services";
import {
  extractOrderId,
  savePendingHandbookOrderId,
} from "../../../../../../../custom_utilities/paytm_payment/paytmHandbookHelpers";

const PaymentWebView = ({ setOrderIdAction, setPaytmDataInStoreAction }) => {
  const history = useHistory();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const { handleBookDetails } = location.state || {};

  const navigateToHandbookPaymentPage = (paytmData) => {
    const orderIdValue = extractOrderId(paytmData);
    if (!orderIdValue) return false;

    setPaytmDataInStoreAction(paytmData);
    savePendingHandbookOrderId(orderIdValue);
    history.push(
      `/handbook_payment_gateway?order_id=${encodeURIComponent(
        orderIdValue
      )}&await_payment=1`
    );
    return true;
  };

  const handlePayment = async () => {
    setIsLoading(true);

    try {
      const payload = {
        user_id: handleBookDetails?.user_id || handleBookDetails?.userId,
        product_id: handleBookDetails?.product_id || handleBookDetails?.productId,
        price: handleBookDetails?.price,
        discount: handleBookDetails?.discount || 0,
        coupon_discount: handleBookDetails?.coupon_discount || 0,
        shipping_charge: handleBookDetails?.shipping_charge || 0,
        total_price:
          handleBookDetails?.total_price || handleBookDetails?.discounted_price,
        from_cart: handleBookDetails?.from_cart === true ? "true" : "false",
        coins_count: handleBookDetails?.coins_count || "0",
        is_referal: handleBookDetails?.is_referal || 0,
      };

      const response = await axios.post(url_301, payload);
      const responseData = response.data?.data || response.data;

      const orderIdValue = extractOrderId(responseData);

      setOrderIdAction(orderIdValue);
      navigateToHandbookPaymentPage(responseData);
    } catch (err) {
      setIsLoading(false);
      history.push("/dashboard");
    }
  };

  return (
    <div style={{ flex: 1 }}>
      {isLoading && <LoaderPopUp />}
      <button onClick={handlePayment} disabled={isLoading}>
        Proceed to Payment
      </button>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setOrderIdAction: (payload) => dispatch(setOrderId(payload)),
  setPaytmDataInStoreAction: (payload) => dispatch(setPaytmDataInStore(payload)),
});

export default connect(null, mapDispatchToProps)(PaymentWebView);
